module.exports = __webpack_public_path__ + "img/pinsx.398f58d9.png";